<template>
  <Transition name="sp">
    <div v-if="loading" class="sp"><div class="sp-bg" /><div class="sp-box"><div class="sp-ring" /></div></div>
  </Transition>
</template>
<script>
export default { props: { loading: { type: Boolean, required: true } } }
</script>
<style scoped>
.sp { position: fixed; inset: 0; z-index: 500; display: flex; align-items: center; justify-content: center; }
.sp-bg { position: absolute; inset: 0; background: rgba(0,0,0,.2); }
[data-theme="dark"] .sp-bg { background: rgba(0,0,0,.45); }
.sp-box { position: relative; width: 56px; height: 56px; border-radius: 16px; background: var(--c-surface); box-shadow: var(--c-shadow-md); display: flex; align-items: center; justify-content: center; }
.sp-ring { width: 24px; height: 24px; border: 2.5px solid var(--c-border); border-top-color: var(--c-primary); border-radius: 50%; animation: spin .7s linear infinite; }
.sp-enter-active { transition: opacity .12s; }
.sp-leave-active { transition: opacity .18s; }
.sp-enter-from, .sp-leave-to { opacity: 0; }
</style>
